import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '../../services/app.service';

@Directive({
  selector: '[nkIfCustomer]',
  standalone: true,
})
export class IfCustomerDirective implements OnInit, OnDestroy {
  /**
   * app_customer_slug
   */
  @Input() public nkIfCustomer: string[] | undefined;
  @Input() public nkIfCustomerElse: TemplateRef<unknown> | undefined;
  private _destroy$ = new Subject<void>();

  constructor(
    private _templateRef: TemplateRef<unknown>,
    private _viewContainer: ViewContainerRef,
    private _appService: AppService,
  ) {}

  public ngOnInit(): void {
    if (this.nkIfCustomer) {
      // clear the view first and subscribe to check if is allowed to access
      this._viewContainer.clear();
      this._subscribeForIdentity();
    } else {
      // if key is not provided, it is assumed that feature check is not required at all
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }

  private _subscribeForIdentity(): void {
    this._appService.identityDataCache
      .get()
      .pipe(takeUntil(this._destroy$))
      .subscribe((identity) => {
        if (Array.isArray(this.nkIfCustomer) && this.nkIfCustomer.includes(identity.app_customer.slug)) {
          this._viewContainer.createEmbeddedView(this._templateRef);
        } else {
          if (this.nkIfCustomerElse) {
            this._viewContainer.createEmbeddedView(this.nkIfCustomerElse);
          } else {
            this._viewContainer.clear();
          }
        }
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
  }
}
